module.exports = __webpack_public_path__ + "img/face-relieved.8883cfa7.svg";